import DialogFunctions from "../../../core/dialogFunctions";

class ApproveReimbursementDialogController extends DialogFunctions {
  constructor($mdDialog, fineReimbursement) {
    "ngInject";

    super($mdDialog);
    this.model = { ...fineReimbursement };
  }
}

export default ApproveReimbursementDialogController;



// WEBPACK FOOTER //
// ./src/pages/fineReimbursement/approveReimbursementDialog/approveReimbursementDialog.controller.js